module.exports = __webpack_public_path__ + "media/images/flags/64/Sri-Lanka-588f2042a5b829694bd6d74d892e3c4f.png";